import { httpCreate } from './http';

const http = httpCreate('/srv/marketing-sms-template');

export const marketingSmsTemplate = {
	getListByActivityId(params) {
		return http.get('/used', { params });
	},
	save(body) {
		return http.post('/save', body);
	},
	delete(templateId) {
		return http.delete(`/delete/${templateId}`);
	},

	getSignature() {
		return http.get('/signature');
	},
	add(data) {
		return http.post('/add', data);
	},
	editor(id, data) {
		return http.put(`/${id}`, data);
	},
	getUseList(params) {
		return http.get('/list/used', { params });
	},
	getList(params) {
		return http.get('/list', { params });
	},
	getListNum() {
		return http.get('/list/num');
	},
};
